// extracted by mini-css-extract-plugin
export default {"container":"container__LQVsG","tabs":"tabs__I+ul-","grid":"grid__DR64I","wrap":"wrap__w6XH+","active":"active__Igv+L"};